import Button from '@/components/elements/forms/buttons/Button/Button';
import ListInput from '@/components/elements/forms/listInput/ListInput/ListInput';
import Icon from '@/components/icons/Icon';
import BottomSheetModal from '@/components/modules/modals/BottomSheetModal';
import Modal from '@/components/modules/modals/redesign/Modal/Modal';
import { validatePhoneNumber } from '@/helpers/userHelper';
import useMobileView from '@/hooks/useMobileView';
import { _t } from '@/locale';
import { useState } from 'react';

interface WalleyPhoneModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (phone: string) => void;
}

const WalleyPhoneModal = ({ isOpen, onClose, onSubmit }: WalleyPhoneModalProps) => {
  const { isMobileView } = useMobileView();
  const [phoneValue, setPhoneValue] = useState('');
  const [error, setError] = useState<string | undefined>(undefined);

  const handleSubmit = () => {
    if (!validatePhoneNumber(phoneValue)) {
      setError(_t('walleyPhoneModalError'));
      return;
    }
    setError(undefined);
    onSubmit(phoneValue);
  };

  const handleClose = () => {
    setPhoneValue('');
    setError(undefined);
    onClose();
  };

  const content = (
    <div className="gap-xxl p-3xl flex flex-col items-center">
      <img src="/images/logos/walley.svg" alt="Walley" style={{ height: '61px', width: 'auto' }} />
      <div className="gap-sm flex flex-col items-center text-center">
        <h2 className="text-h-m font-bold">{_t('walleyPhoneModalTitle')}</h2>
        <p className="text-fg_secondary text-l">{_t('walleyPhoneModalDescription')}</p>
      </div>
      <div className="gap-md flex w-full flex-col">
        <div className="w-full rounded-sm bg-white">
          <ListInput
            id="walley-phone"
            label={_t('walleyPhoneModalPlaceholder')}
            floatStyle={true}
            type="tel"
            inputMode="tel"
            autoComplete="tel"
            value={phoneValue}
            onChange={(e) => {
              setPhoneValue(e.target.value);
              if (error) setError(undefined);
            }}
            leftIcon={<Icon variant="phone" />}
            error={error}
            inputValue={phoneValue}
            setValue={(_, value) => setPhoneValue(value)}
            leftPadding={false}
            rightPadding={false}
            className="bg-transparent"
          />
        </div>
        <Button variant="primary" size="lg" block label={_t('walleyPhoneModalCTA')} onClick={handleSubmit} />
      </div>
    </div>
  );

  if (isMobileView) {
    return (
      <BottomSheetModal isOpen={isOpen} onClose={handleClose} title={_t('walleyPhoneModalHeader')}>
        {content}
      </BottomSheetModal>
    );
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={handleClose}>
      <Modal.Content newDesign={true} contentPadding={false} floating={true} contentMaxWidth={500}>
        <Modal.Header newDesign={true} floating={true} onClose={handleClose} title={_t('walleyPhoneModalHeader')} />
        {content}
      </Modal.Content>
    </Modal>
  );
};

export default WalleyPhoneModal;
